"use client";

import { Link } from "@/components/common/Link";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Cart() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="2091" id="cart-content" className="relative bg-background text-foreground py-28 md:py-36 overflow-hidden">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        {}
        <div ref={headerRef} className="relative" style={{
        opacity: headerVisible ? 1 : 0,
        transform: headerVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 700ms cubic-bezier(0.16, 1, 0.3, 1), transform 700ms cubic-bezier(0.16, 1, 0.3, 1)"
      }}>
          {}
          <div aria-hidden="true" className="pointer-events-none absolute -top-6 right-0 md:right-8 select-none font-default text-foreground/5" style={{
          fontSize: "14rem",
          lineHeight: 1,
          fontWeight: 800,
          WebkitTextStroke: "0.5px currentColor",
          WebkitTextFillColor: "transparent"
        }}>
            08
          </div>

          {}
          <div className="relative flex items-center gap-3">
            <span className="font-mono text-primary uppercase" style={{
            fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
            fontWeight: 500,
            letterSpacing: "0.2em",
            lineHeight: 1.4
          }}>
              &sect; BATCH &mdash; REVIEW
            </span>
          </div>

          {}
          <h1 className="relative mt-3 font-default text-foreground" style={{
          fontSize: "clamp(2.25rem, 4.6vw, 4.5rem)",
          fontWeight: 800,
          letterSpacing: "-0.04em",
          lineHeight: 1.0
        }}>
            Your <em className="italic font-serif">Performance</em> Order.
          </h1>

          {}
          <div className="relative mt-12 flex items-center" aria-hidden="true">
            <span className="inline-block h-px w-12 bg-primary shrink-0" />
            <span className="h-px flex-1 bg-border" />
          </div>
        </div>

        {}
        <div className="relative mt-12 md:mt-16">
          {}
          <CoordinateTick className="absolute -top-2 -left-2" />
          <CoordinateTick className="absolute -top-2 -right-2" />
          <CoordinateTick className="absolute -bottom-2 -left-2" />
          <CoordinateTick className="absolute -bottom-2 -right-2" />

          {}
          <div className="relative">
            <WooCommerceCartBlock />
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-20 flex justify-center md:justify-start">
          <Link to="/ShopPage" className="group inline-flex items-center gap-2 font-mono uppercase text-foreground hover:text-primary transition-colors duration-200" style={{
          fontSize: "0.75rem",
          fontWeight: 500,
          letterSpacing: "0.14em",
          textUnderlineOffset: "6px",
          textDecoration: "underline",
          textDecorationThickness: "0.5px"
        }}>
            <span>Return to the laboratory</span>
            <span aria-hidden="true" className="inline-block transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
              &#8599;
            </span>
          </Link>
        </div>
      </div>
    </section>;
}
function CoordinateTick({
  className = ""
}: {
  className?: string;
}) {
  return <span aria-hidden="true" className={`pointer-events-none inline-block text-primary/40 ${className}`} style={{
    width: "8px",
    height: "8px"
  }}>
      <svg viewBox="0 0 8 8" width="8" height="8" fill="none" stroke="currentColor" strokeWidth="1" aria-hidden="true">
        <line x1="4" y1="0" x2="4" y2="8" />
        <line x1="0" y1="4" x2="8" y2="4" />
      </svg>
    </span>;
}